const HITS_URL = "https://hits.jackpettit.dev/hit";

export function servedLocally(): boolean {
  return ["localhost", "127.0.0.1", "[::1]"].includes(location.hostname) || location.hostname.endsWith(".localhost");
}

export function recordPageHit(ref: string): void {
  if (servedLocally()) return;
  const path = location.pathname.replace(/^\/r\/\d+(?=\/)/, "");
  void fetch(HITS_URL, { method: "POST", body: JSON.stringify({ path, ref }) }).catch(() => {});
}
